<mat-toolbar [style.background-color]="navbarBgClass()">
  <button mat-icon-button (click)="toggle.emit()">
    <mat-icon svgIcon="sqep:menu" />
  </button>
  <a [routerLink]="'/home'" (click)="setHomeMenu()">
    <img
      [src]="'../assets/' + clientLogoAsset()"
      id="clientLogo"
      alt="Client logo"
    />
  </a>
  <span class="toolbar-spacer"></span>

  <button (click)="openHelp()" class="help-button">Help</button>

  <sqep-person-detail-navbar />
</mat-toolbar>
